import React, { useEffect, useRef } from "react";
import mermaid from "mermaid";

mermaid.initialize({
  startOnLoad: false,
  theme: "dark",
  securityLevel: "loose",

  flowchart: {
    nodeSpacing: 15,
    rankSpacing: 25,
    padding: 5,
    useMaxWidth: false,
  },

  themeVariables: {
    background: "#0b0f19",
    primaryColor: "#ff6b00",
    primaryTextColor: "#ffffff",
    lineColor: "#ff6b00",
    fontSize: "10px",
  },
});

interface MermaidDiagramProps {
  chart: string;
}

export default function MermaidDiagram({ chart }: MermaidDiagramProps) {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    let isMounted = true;
    const renderChart = async () => {
      if (!chart) return;
      try {
        const id = `mermaid-${Math.floor(Math.random() * 1000000)}`;
        
        // Render the diagram
        const { svg } = await mermaid.render(id, chart);

        if (isMounted && containerRef.current) {
          containerRef.current.innerHTML = svg;
          
          // Apply styling to SVG
          const svgElement = containerRef.current.querySelector("svg");
          if (svgElement) {
            svgElement.style.width = "50%";
            svgElement.style.maxWidth = "450px";
            svgElement.style.height = "auto";
            svgElement.style.margin = "0 auto";
            svgElement.style.display = "block";
          }
        }
      } catch (error) {
        console.error("Mermaid parsing/rendering error:", error);
        
        // Clean up bad mermaid internal elements if generated in body
        const badElements = document.querySelectorAll(`[id^="d"]`);
        badElements.forEach(el => {
          if (el.parentNode === document.body) {
            el.remove();
          }
        });
        
        if (isMounted && containerRef.current) {
          containerRef.current.innerHTML = `<div class="p-6 border border-red-500/20 bg-red-500/10 text-red-400 rounded-xl text-xs font-mono max-w-md text-center">
            <strong class="text-sm block mb-1">Mermaid Rendering Issue</strong>
            There is a syntax error in the flowchart code generated by AI.<br/>
            Please click "Regenerate Process" to request a clean compile.
          </div>`;
        }
      }
    };

    renderChart();

    return () => {
      isMounted = false;
    };
  }, [chart]);

  return (
    <div 
      ref={containerRef} 
      className="mermaid w-full flex justify-center items-start overflow-auto p-2" 
    />
  );
}
